module.exports = __webpack_public_path__ + "img/laravel.3ad7c56c.png";